
import {createContext, useState} from 'react'

const Context = createContext()

export const ErrorContextProvider = ({children}) => {
 const [allErrors, setAllErrors] = useState([])
 const [allErrorsByUser, setAllErrosByUser]  = useState([]);
 const [error, setError] = useState({});
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState({
  message: '',
  status: 200
 })


 return <Context.Provider value={{allErrors, setAllErrors, allErrorsByUser, setAllErrosByUser, error, setError, message, setMessage, loading, setLoading}}>
  {children}
 </Context.Provider>
}
export default Context